import React, { useEffect, useState } from "react";
import axios from "axios";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

const API_URL = "https://api.npskudlu.com/api"; // replace with your backend base URL

const GallerySection = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGallery = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/v1/get-gallery`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      });

      const payload = response.data;
      let imgs = [];

      if (Array.isArray(payload?.data)) {
        imgs = payload.data.flatMap((item) => {
          if (!item) return [];
          // item.image can be string or array.
          if (typeof item.image === "string") {
            return [{ image: item.image, title: item.title || "" }];
          }
          if (Array.isArray(item.image)) {
            return item.image.map((imgObj) => ({
              image: typeof imgObj === "string" ? imgObj : imgObj.mediaLink,
              title: item.title || "",
            }));
          }
          return [];
        });
      }

      setImages(imgs.filter(Boolean));
    } catch (err) {
      console.error("Gallery fetch failed:", err);
      setError("Failed to load gallery images.");
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <section className="gallery py-60">
      <div className="container">
        <div className="masonry">
          {loading && <p>Loading gallery...</p>}

          {!loading && !error && images.length === 0 && (
            <p>No images available.</p>
          )}
          {!loading && images.length > 0 && (
            <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
              {images.map((item, idx) => {
                const src = item?.image;
                const title = item?.title || "";
                return (
                  <a
                    key={idx}
                    className="masonry__item position-relative rounded-12 overflow-hidden"
                    href={src}
                    style={{ display: "block" }}
                  >
                    <img
                      alt={title}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                        display: "block",
                      }}
                      src={src}
                    />
                  </a>
                );
              })}
            </LightGallery>
          )}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
